<template>
    <div>
        <v-layout wrap justify-center py-10>
            <v-flex xs9>
              <v-card elevation="0">
                <v-layout wrap>
                  <v-flex xs12 text-justify>
                   
                <span style="font-family:poppinsregular; text-align: justify; font-size: 16px;">{{ productdes.descriptionDetails }}</span>
                    <!-- Add content for technical information here -->
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
  
    </div>
</template>


<script>
import axios from "axios";
export default {
  
  data() {
    return {
      tab: 0, // To control the active tab
      rate: 4, // Example rating value
      dialog: false, // To control the review dialog
      //productspec:[],
      productdes:[],
    };
  },
  beforeMount() {
    this.productSpecDes();
  },
  methods:{
    productSpecDes() {
      this.appLoading = true;
      // var headers1 = {};
      // if (this.appLogin) {
      //   headers1 = {
      //     token: localStorage.getItem("token"),
      //   };
      // } else {
      //   headers1 = {
      //     guestId: localStorage.getItem("userId"),
      //   };
      // }
      axios({
        url: "/product/specificationAndDescription",
        method: "POST",
        data: {
          productId: this.$route.query.id,
          id:localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
        },
        // headers: headers1,
      })
        .then((response) => {
          this.appLoading = false;
          //this.productspec = response.data.specifications;
          this.productdes = response.data.descriptions;
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
  }
};
</script>

<style scoped>
/* Add any custom styles you may need */
</style>
